import { render, staticRenderFns } from "./c-icon-background.vue?vue&type=template&id=ddffedee&"
import script from "./c-icon-background.vue?vue&type=script&lang=js&"
export * from "./c-icon-background.vue?vue&type=script&lang=js&"
import style0 from "./c-icon-background.vue?vue&type=style&index=0&id=ddffedee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports